<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="my-3 d-flex justify-content-between">
      <div class="font20">Department Setup</div>
      <div>
        <button
          class="btn btn-outline-secondary btn-sm "
          data-toggle="modal"
          data-target="#addDepartmentModal"
        >
          Add Department
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-sm-12 vertical-nav my-3">
        <div class="bg-white border-radius py-4 px-3">
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link click"
              [class]="department.id == departmentId ? 'active' : ''"
              (click)="selectDepartment(department.id, department)"
              *ngFor="let department of departments, index as i"
              >
              <div class="d-flex justify-content-between">
                  <span class="font16 font-bold">{{ department?.name }}</span>
                  <span 
                    data-toggle="modal"
                    [attr.data-target]="'#editDepartmentModal'+department.id"
                    id="editDepartment{{ i }}"
                    ><i class="far fa-edit font16"></i></span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-sm-12 my-3 lg-column-pills">
        <div class="bg-white border-radius py-4">
          <div class="tab-content" id="v-pills-tabContent">
            <div
              class="tab-pane fade show active"
              [attr.id]="'v-pills-'+deptDetail?.name"
              role="tabpanel"
              aria-labelledby="'v-pills-'+deptDetail.name+'-tab'"
            >
            <div>
                <div class="px-3 ">
                    <h5 class="font18">{{ deptDetail?.name }}</h5>
                </div><hr>
                <div>
                <ul class="nav nav-pills mb-3 mx-3 px-3" id="pills-tab" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link active" id="pills-Division-tab" data-toggle="pill" href="#pills-Division" role="tab" aria-controls="pills-Division" aria-selected="true">Division</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" id="pills-Units-tab" data-toggle="pill" href="#pills-Units" role="tab" aria-controls="pills-Units" aria-selected="false">Units</a>
                    </li>
                  </ul>
                  <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-Division" role="tabpanel" aria-labelledby="pills-Division-tab">
                        
                <div class="px-3">
                    <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                        <div class="">
                            <div>Maintainance</div>
                        </div>
                        <div>
                            <img src="assets/images/close.png" alt="">
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                        <div>
                            <div>Purchase</div>
                        </div>
                        <div>
                            <img src="assets/images/close.png" alt="">
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                        <div>
                            <div>Client Services</div>
                        </div>
                        <div>
                            <img src="assets/images/close.png" alt="">
                        </div>
                    </div>
                </div>
                    </div>
                    <div class="tab-pane fade" id="pills-Units" role="tabpanel" aria-labelledby="pills-Units-tab">
                        
                <div class="px-3">
                    <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                        <div>
                            <div>Maintainance</div>
                        </div>
                        <div>
                            <img src="assets/images/close.png" alt="">
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                        <div>
                            <div>Purchase</div>
                        </div>
                        <div>
                            <img src="assets/images/close.png" alt="">
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between bg-grey border-radius my-3 p-3">
                        <div>
                            <div>Client Services</div>
                        </div>
                        <div>
                            <img src="assets/images/close.png" alt="">
                        </div>
                    </div>
                </div>
                    </div>
                  </div>
                  </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-wrapper mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>


<!-- Modal -->
<app-modal
  elementId="addDepartmentModal"
  headerTitle="Add Department"
  centered="true"
  [styles]="{
    modalBodyHeight: '180px',
    modalContentWidth: '421px'
  }"
>
  <div class="content">
    <hr class="hline" />
    <div class="form-row mt-5">
      <div class="d-flex justify-content-center mb-4 form-group w-100">
        <input
          type="text"
          class="text-start form-control "
          placeholder="Enter Department Name"
          [(ngModel)]="departmentForm"
          [ngClass]="{
            'is-invalid': !departmentForm
          }"
        />
        <span class="text-danger">*</span>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <button
        data-dismiss="modal"
        (click)="addDepartment()"
        class="modalBtn btn-secondary"
        type="button"
        [disabled]="!departmentForm"
      >
        Add Department
      </button>
    </div>
  </div>
</app-modal>

<app-modal
  [elementId]="'editDepartmentModal' + department.id"
  headerTitle="Edit Department"
  centered="true"
  [styles]="{
    modalBodyHeight: '180px',
    modalContentWidth: '421px'
  }"
  *ngFor="let department of departments"
>
  <div class="content">
    <hr class="hline" />
    <div class="form-row mt-5">
      <div class="d-flex justify-content-center mb-4 form-group w-100">
        <input
          type="text"
          class="text-start form-control "
          placeholder="{{ department.name }}"
          [(ngModel)]="editDepartmentForm"
          [ngClass]="{
            'is-invalid': !editDepartmentForm
          }"
        />
        <span class="text-danger">*</span>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <button
        data-dismiss="modal"
        (click)="updateDepartment(department.id)"
        class="modalBtn btn-secondary"
        type="button"
        [disabled]="!editDepartmentForm"
      >
        Update
      </button>
    </div>
  </div>
</app-modal>
